import React, { useEffect, useRef } from "react";


import scrollToDomElement from "@Utilities/Scrolling";


type PageContainerComponentProps = {
    pageType: string;
    children: React.ReactNode | React.ReactNode[];
};


export const PageContainerComponent:React.FC<PageContainerComponentProps> = ({
    pageType, children
}) => {

    const pageComponentRef = useRef(null);

    useEffect(() => {
        if (pageComponentRef?.current) {
            scrollToDomElement(pageComponentRef.current);
        }
    }, []);

    return (
        <div ref={pageComponentRef} className={`page-component ${pageType}-page`}>
            {children}
        </div>
    );

};


export default PageContainerComponent;
